import { rankWith, scopeEndsWith } from '@jsonforms/core';

export default rankWith(
  6, //increase rank as needed
  scopeEndsWith('autocomplete')
);
